// extracted by mini-css-extract-plugin
module.exports = {"sportCardsService":"sportCardsService_sportCardsService__NebrO","final":"sportCardsService_final__10q6w"};